// extracted by css-extract-rspack-plugin
export default {"whiteSlider":"src-components-Sliders-CustomSlider-module__whiteSlider-JRAr7t","sliderTooltip":"src-components-Sliders-CustomSlider-module__sliderTooltip-NNbevO","sliderTooltipVisible":"src-components-Sliders-CustomSlider-module__sliderTooltipVisible-VRAGj5","sliderTooltipArrow":"src-components-Sliders-CustomSlider-module__sliderTooltipArrow-vZSk09"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"whiteSlider\":\"src-components-Sliders-CustomSlider-module__whiteSlider-JRAr7t\",\"sliderTooltip\":\"src-components-Sliders-CustomSlider-module__sliderTooltip-NNbevO\",\"sliderTooltipVisible\":\"src-components-Sliders-CustomSlider-module__sliderTooltipVisible-VRAGj5\",\"sliderTooltipArrow\":\"src-components-Sliders-CustomSlider-module__sliderTooltipArrow-vZSk09\"}";
        // 1791855167386
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  